import React from "react";

export const Tick = ({ color = "#202020", width="32",height="32"}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.82316 17.1794L5.82315 17.1794C5.6055 16.9618 5.31031 16.8395 5.00251 16.8395C4.69471 16.8395 4.39952 16.9618 4.18187 17.1794C3.96423 17.3971 3.84195 17.6923 3.84195 18.0001C3.84195 18.3079 3.96423 18.6031 4.18187 18.8207L11.1818 25.8206C11.2895 25.9285 11.4175 26.0141 11.5583 26.0724C11.6991 26.1308 11.8501 26.1609 12.0025 26.1609C12.155 26.1609 12.3059 26.1308 12.4467 26.0724C12.5875 26.0141 12.7155 25.9285 12.8232 25.8206L28.8232 9.82071L28.71 9.70757L28.8232 9.8207C29.0408 9.60306 29.1631 9.30787 29.1631 9.00007C29.1631 8.69227 29.0408 8.39708 28.8232 8.17943L28.7107 8.29189L28.8232 8.17943C28.6055 7.96178 28.3103 7.83951 28.0025 7.83951C27.6947 7.83951 27.3995 7.96178 27.1819 8.17943L27.1819 8.17943L12.0025 23.36L5.82316 17.1794Z"
        fill={color}
        stroke={color}
        stroke-width="1"
      />
    </svg>
  );
};
